import { getAnalytics } from "firebase/analytics";
import { FirebaseApp, getApps, initializeApp } from "firebase/app";
import { Auth, getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BAKET,
  messagingSenderId: process.env.FIREBASE_MESSAGE_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
  measurementId: process.env.FIREBASE_MEASUREMENT_ID,
};

export const firebaseApp: FirebaseApp = getApps()[0] || initializeApp(firebaseConfig);

export const firebaseStorage = getStorage(firebaseApp);
export const firestoreDB = getFirestore(firebaseApp);
export const firebaseAuth = getAuth(firebaseApp);
export const firebaseGetAuth: Auth = getAuth(firebaseApp);
if (typeof window !== "undefined") {
  getAnalytics(firebaseApp);
}

export const API_URL = process.env.API_URL || "";
export const APP_ENV = process.env.APP_ENV || "";
export const FACEBOOK_API_URL = process.env.FACEBOOK_API_URL || "";
export const SAMPLE_IG_ID = process.env.SAMPLE_IG_ID || "";
export const GOOGLE_AUTHENTICATOR_TOKEN = process.env.GOOGLE_AUTHENTICATOR_TOKEN || "";

/**
 * 本番かどうか
 *
 * APP_ENV でも "production" は判定できるが（AppPWA・AppChatSupport・_app などで
 * 実際に使っている）、それが効くのはアプリのビルドだけ。APP_ENV は
 * local / production / staging / admin / corporate の5値フラットな列挙で、
 * 管理画面と法人画面は "admin" / "corporate" になり stg と prd を区別できない。
 *
 *   deploy_dashboard(管理prd) / deploy_stg_dashboard(管理stg) → 同じ ADMIN_APP_ENV
 *   deploy_corp_dashboard(法人prd) / deploy_stg_corp_dashboard(法人stg) → 両方 "corporate"
 *
 * 一方 FIREBASE_PROJECT_ID は6本の workflow すべてで PRD_/STG_ が分かれている。
 * この画面は AdminMenuBar と CorpMenuBar にも出るため、そちらで判定する
 * （plan-data.ts と同じ）。
 */
export const IS_PRODUCTION = process.env.FIREBASE_PROJECT_ID === "hinome-pj-prd";

/**
 * フォロワー分析の画面名
 *
 * リーチ / エンゲージメントの切り替えを隠している間（FollowerTypeHeader.tsx）は
 * フォロワーの属性しか出ないため、全環境で「フォロワー分析」にしている。
 */
export const AUDIENCE_PAGE_LABEL = "フォロワー分析";

// Compatibility: export firebaseApp as default
export default firebaseApp;
